module.exports = "/static/assets/fecd02c29554acc59d39a5fa1ef36f96.png";